// extracted by css-extract-rspack-plugin
export default {"PageLayout":"FindingsPage-module__PageLayout__kvDUA"};